import React, { useState } from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import { AlertDialog } from '../../UI/AlertDialog';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import BlockIcon from '@material-ui/icons/Block';
import OpenInNew from '@material-ui/icons/OpenInNew';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';
import useWindowSize from '../../../customHooks/useWindowSize';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FixedSizeList as List } from 'react-window';
import './styles.css';
import FlowSteps from '../../UI/FlowSteps';
import LoadingCard from '../../UI/LoadingCard';
import DocumentDescription from '../../Document/DocumentList/DocumentDescription';
import { CONSTANTS } from '../../../constants/constants';
import API_REST from '../../../api-rest-uruk';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import GraphqlApi from '../../../api-graphql';

const useStyles = makeStyles(() => ({
  containerName: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  containerButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

function PdfListFromBundle ({ pdfSignedUrl, downloadBundleDocument, renderUploadBtn, input }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const windowSize = useWindowSize();
  const [cancelFlowDialog, setCancelFlowDialog] = useState(false);
  const [deleteFlowDialog, setDeleteFlowDialog] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const mergeSteps = (doc) => {
    const { flow, status } = doc;
    const parsedFlow = typeof flow === 'string' ? JSON.parse(flow) : flow;
    if (parsedFlow && status === 'INIT') {
      doc.flow = false;
    } else if (parsedFlow && parsedFlow.steps.some(step => step.subFlowType === 'subflows')) {
      parsedFlow.steps = parsedFlow.steps.filter((step) => {
        return step.subFlowType !== 'bundle';
      });
      doc.flow = parsedFlow;
    }
    return doc;
  };

  const handlerCancel = async (doc) => {
    setDocumentToDelete(doc);
    setCancelFlowDialog(true);
  };

  const handlerDelete = async (doc) => {
    const { ...rest } = doc;
    delete rest.bundle;
    delete rest.data;
    setDocumentToDelete(rest);
    setDeleteFlowDialog(true);
  };

  const handleCancelFlow = async (choise) => {
    setCancelFlowDialog(false);
    console.log(documentToDelete);
    if (choise) {
      setMessage(t('documentMenu:canceling'));
      setLoading(true);
      console.log(documentToDelete);
      API_REST.cancelFlow(documentToDelete)
        .then(async () => {
          setMessage(t('documentMenu:ready'));
          setTimeout(() => setLoading(false), 2000);
        })
        .catch((err) => {
          console.error(err);
          setMessage(t('documentMenu:error'));
          setTimeout(() => setLoading(false), 2000);
        });
    }
  };

  const handleDeleteDocument = async (choise) => {
    let doc = documentToDelete;
    doc.status = 'deleted';
    doc.updatedAt = new Date().toISOString();
    setDeleteFlowDialog(false);
    if (choise) {
      setMessage(t('documentMenu:delete'));
      setLoading(true);
      await GraphqlApi.updateDocument(documentToDelete)
        .then(async () => {
          setMessage(t('documentMenu:ready'));
          setTimeout(() => {
            setLoading(false);
            window.location.reload();
          }, 2000);
        }).catch((err) => {
          console.error(err);
          setMessage(t('documentMenu:error'));
          setTimeout(() => setLoading(false), 2000);
        });
    }
  };

  const renderList = ({ index, style }) => {
    const url = pdfSignedUrl[index];
    const document = input.items[index];
    document.bundle = input.bundleDocument;

    let currentStep;
    let flow;
    if (document.flow) {
      flow = JSON.parse(document.flow);
      currentStep = flow.steps.find(step => step.status === CONSTANTS.FLOW.STATUS.SEND_TO_SIGN);
    }

    const unifiedFlowSteps = windowSize.width > 500 ? mergeSteps({ ...document }) : {};
    return (
      <Grid container className={'ListItemEven'} style={{ ...style, height: 'none' }}>
        <Grid item lg={2} md={2} sm={3} xs={5} className={classes.containerName} >
          <DocumentDescription key={input.items[index].id} document={input.items[index]} />
        </Grid>
        <Grid item lg={8} md={8} sm={7} xs={1}>
          { document.flow && windowSize.width > 500 &&
            <FlowSteps document={unifiedFlowSteps} nonLinear />
          }
        </Grid>
        <Grid item lg={2} md={2} sm={2} xs={5} className={classes.containerButtons} >
          <Tooltip disableFocusListener title={t('viewer:downloadDocument')}>
            <IconButton
              onClick={() => downloadBundleDocument(url)}
              style={{ color: 'black' }}>
              <SaveAltIcon style={{ fontSize: '18px' }} />
            </IconButton>
          </Tooltip>
          <Tooltip disableFocusListener title={t(`processDetail:document`)}>
            <IconButton component={RouterLink} to={`/document/detail/${document.id}`} style={{ color: 'black' }}>
              <OpenInNew style={{ fontSize: '18px' }} />
            </IconButton>
          </Tooltip>
          {document.status === CONSTANTS.FLOW.STATUS.SEND_TO_SIGN && currentStep && !currentStep.automatic &&
          <Tooltip disableFocusListener title={t('documentMenu:cancel')}>
            <IconButton onClick={() => handlerCancel({ flowId: document.flowId, documentId: document.id })} style={{ color: 'black' }}>
              <BlockIcon style={{ fontSize: '18px' }} />
            </IconButton>
          </Tooltip>
          }
          {(document.status === CONSTANTS.FLOW.STATUS.REJECTED || document.status === CONSTANTS.FLOW.STATUS.CANCELLED || document.status === CONSTANTS.FLOW.STATUS.INIT || document.status === CONSTANTS.FLOW.STATUS.ERROR) &&
          <Tooltip disableFocusListener title={t('documentMenu:delete')}>
            <IconButton onClick={() => handlerDelete(document)} style={{ color: 'black' }}>
              <DeleteForeverIcon style={{ fontSize: '18px' }} />
            </IconButton>
          </Tooltip>}
          {renderUploadBtn(index)}
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <List className='List' height={600} itemCount={pdfSignedUrl.length} itemSize={105} width={'100%'}>
        {renderList}
      </List>
      {cancelFlowDialog &&
      <AlertDialog
        description={t('documentMenu:cancelConfirmationMessage')}
        callbackFunc={handleCancelFlow}
        open={cancelFlowDialog}
        setOpen={setCancelFlowDialog}
      />}
      {deleteFlowDialog &&
      <AlertDialog
        description={t('documentMenu:deleteConfirmationMessage')}
        callbackFunc={handleDeleteDocument}
        open={deleteFlowDialog}
        setOpen={setDeleteFlowDialog}
      />}
      <LoadingCard open={loading} loading={loading} message={message} />
        </>
  );
}

PdfListFromBundle.propTypes = {
  pdfSignedUrl: PropTypes.array.isRequired,
  downloadBundleDocument: PropTypes.func.isRequired,
  renderUploadBtn: PropTypes.func.isRequired,
  input: PropTypes.object.isRequired,
  filesName: PropTypes.array.isRequired
};

export default PdfListFromBundle;
